import { LabelledDateRange } from '@teetsh/app/src/types/zone';
import isSameDay from '@teetsh/app/src/utils/time/isSameDay';
import isBefore from '@teetsh/app/src/utils/time/isBefore';
import isAfter from '@teetsh/app/src/utils/time/isAfter';

export function getHolidaysWithinInterval(
  fromDate: Date,
  toDate: Date,
  holidays: LabelledDateRange[],
): (LabelledDateRange & { from: Date; to: Date })[] {
  return holidays
    .filter(
      (
        d: LabelledDateRange,
      ): d is LabelledDateRange & { from: Date; to: Date } =>
        d.from !== undefined && d.to !== undefined,
    )
    .filter(h => {
      const { from, to } = h;
      if (
        isSameDay(fromDate, from) ||
        isSameDay(fromDate, to) ||
        isSameDay(toDate, from) ||
        isSameDay(toDate, to)
      ) {
        return true;
      }
      return !(
        (isBefore(toDate, from) && isBefore(fromDate, from)) ||
        (isAfter(toDate, to) && isAfter(fromDate, to))
      );
    });
}
